export class ConfigProvider {
  //static host = 'http://qative.ddns.net:4500';
  //static host = 'http://192.168.2.175:4500';
  //static host = 'http://192.168.2.110:8000';
  //static host = 'http://192.168.2.123:8083';
  //static host = 'https://api.medbrasil.com.br';
  static host = "https://api-contratos.medbrasil.com.br";
  //static host = "https://sandbox.medbrasil.com.br";
  //static host = 'https://sand-api-kora.medbrasil.com.br';
  //static host = 'https://api-kora.medbrasil.com.br';
  //static host= 'http://apimedbrasil.test';
  //static host= 'http://apikora.test';
  //static token = "4Vvy4LbPsVt27jo2o3xq9JwHsC13rbdsptRJ6ZsQ" //medteste
  static token = 'EevpqdkJjxquruF0nwfbChw29cf8DvIH4duxCYqZ'; //pf

  //static token = "cWPr5xtz9q6d6Up7DWWbvtc7EHiK6WYIfI4tr6kI"; //servir
  //static token = "Z6UTO36NWuPGqTcIb7cdrO9BAGQSAu7AISBe2UEU"; //original
  // static host = 'https://apimedbrasil.test';
  //static host_social = 'https://qimob3.0api.test';

  //static host_social = "https://api-contratos.medbrasil.com.br";
  //static host_social = 'http://qative.ddns.net:4500';
  //static host_social = 'https://api.medbrasil.com.br';
  //static host_social = 'http://localhost:8000';
  //static host_social = 'http://192.168.2.175:4500';

  static language = 'pt_BR';

  //Client Name: MedBrasil
  //Client ID: 1
  //Client Secret: Z6UTO36NWuPGqTcIb7cdrO9BAGQSAu7AISBe2UEU

  //Client Name: PF
  //Client ID: 3
  //Client Secret: JYmaxdHSZHZbturfSFFdipU0GeavOH6sYD6h9YS0
  //Convênio ID : 38

  //Client Name: SERVIR
  //Client ID: 4
  //Client Secret: BaaEUQUVjaLMkeoxQpm7R4cD6cusDtNFl4CDDbIW
  //Convênio ID : 23

  //user: 26063083871
  //password: 26063083871
  static mode: 'dev' | 'production' = 'production';

  static client_id = 4;
  static convenio_id = 1;

  static grant_type = 'password';
  static linkWhatsApp =
    'https://api.whatsapp.com/send?phone=5563999720955&text=&source=&data=&app_absent=';

  static numeroWhatsApp = '063999720955';

  static version_app = 'Versão do app 1.0.14';

  static one_signal_id = '2c8e5729-3f0f-48fc-819b-e69242c07fb7';

  static messaging_system = 2; //ONE SIGNAL
}



// WEBPACK FOOTER //
// ./src/providers/base/config.ts